<mat-form-field appearance="outline" class="w-full">
    <mat-select [ngModel]="role" (ngModelChange)="onInputChange($event)">
        @for (userRole of userRoles; track userRole) {
            <mat-option [value]="userRole">{{
                UserRoleLabelMapping[userRole]
            }}</mat-option>
        }
    </mat-select>
</mat-form-field>
